import WithdrawList from "../views/transactionManagement/withdrawList";
import WithdrawMethod from "../views/transactionManagement/withdrawMethod";
import AdvanceOrderList from "../views/transactionManagement/advanceOrderList";
import RechargeList from "../views/transactionManagement/rechargeList";
import WithdrawBank from "../views/transactionManagement/withdrawBank";
import TransferList from "../views/transactionManagement/transferList";
import WithdrawRefund from "../views/transactionManagement/withdrawRefund";
import AiTradeList from "../views/transactionManagement/aiTradeList";
import AiChangeFaceStencil from "../views/transactionManagement/aiChangeFaceStencil";
import AiChangeFaceList from "../views/transactionManagement/aiChangeFaceList";
import AiChangeFaceImgList from "../views/transactionManagement/aiChangeFaceImgList";
import AiImageToVideoList from "../views/transactionManagement/aiImageToVideoList";
import AiDrawList from "../views/transactionManagement/aiDrawList";
import Main from "../views/main";
const TransactionRouter = {
  path: "/recharge-list",
  component: Main,
  title: "交易管理",
  icon: "el-icon-sort",
  meta: { keepAlive: true },
  children: [
    {
      path: "/recharge-list",
      component: RechargeList,
      name: "rechargeList",
      title: "充值订单管理",
      meta: { title: "充值订单管理", keepAlive: true },
    },
    {
      path: "/withdraw-list",
      component: WithdrawList,
      name: "withdrawList",
      title: "提现订单列表",
      meta: { title: "提现订单列表", keepAlive: true },
    },
    {
      path: "/advance-order-list",
      component: AdvanceOrderList,
      name: "advanceOrderList",
      title: "预售订单列表",
      meta: { title: "预售订单列表", keepAlive: true },
    },
    {
      path: "/ai-trade-list",
      component: AiTradeList,
      name: "aiTradeList",
      title: "AI脱衣交易列表",
      meta: { title: "AI脱衣交易列表", keepAlive: true },
    },
    {
      path: "/ai-change-face-stencil",
      component: AiChangeFaceStencil,
      name: "aiChangeFaceStencil",
      title: "AI换脸模版列表",
      meta: { title: "AI换脸模版列表", keepAlive: true },
    },
    {
      path: "/ai-change-face-list",
      component: AiChangeFaceList,
      name: "aiChangeFaceList",
      title: "AI换脸交易列表",
      meta: { title: "AI换脸交易列表", keepAlive: true },
    },
    {
      path: "/ai-change-face-img-list",
      component: AiChangeFaceImgList,
      name: "aiChangeFaceImgList",
      title: "AI图片换脸交易列表",
      meta: { title: "AI图片换脸交易列表", keepAlive: true },
    },
    {
      path: "/ai-image-to-video-list",
      component: AiImageToVideoList,
      name: "AiImageToVideoList",
      title: "AI图生视频列表",
      meta: { title: "AI图片换脸交易列表", keepAlive: true },
    },
    {
      path: "/ai-draw-list",
      component: AiDrawList,
      name: "AiDrawList",
      title: "AI绘图列表",
      meta: { title: "AI绘图列表", keepAlive: true },
    },
    {
      path: "/withdraw-method",
      component: WithdrawMethod,
      name: "withdrawMethod",
      title: "提现方式配置",
      meta: { title: "提现方式配置", keepAlive: true },
    },
    {
      path: "/withdraw-bank",
      component: WithdrawBank,
      name: "withdrawBank",
      title: "提现银行配置",
      meta: { title: "提现银行配置", keepAlive: true },
    },
    {
      path: "/transfer-list",
      component: TransferList,
      name: "transferList",
      title: "财务转账列表",
      meta: { title: "财务转账列表", keepAlive: true },
    },
    {
      path: "/withdraw-refund",
      component: WithdrawRefund,
      name: "withdrawRefund",
      title: "提现退款列表",
      meta: { title: "提现退款列表", keepAlive: true },
    },
  ],
};
export default TransactionRouter;
